'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import { regional, unity, business } from '../../modules/select';
import { modalSaveReport } from '../../modules/modalSaveReport';
import { isValidEmail } from '../../utils/helpers';
import { submitSubscribesForm, callSubscribesForm } from '../../modules/subcribesForm';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    modal_attention: 'Atenção!',
    modal_fields: 'Preencha os campos corretamente',
    modal_error_email: 'E-mail inválido',
  },
  en: {
    modal_attention: 'Attention!',
    modal_fields: 'Please fill out all the fields correctly',
    modal_error_email: 'Invalid e-mail',
  },
  es: {
    modal_attention: '¡Atención!',
    modal_fields: 'Rellena los campos correctamente',
    modal_error_email: 'Correo electrónico no válido',
  },
};

const resetEmployeeFields = () => {
  $('#employee_fields').find('input, select').val('');
  $('#employee_fields').addClass('u-display--none');
  $('[name="regional_id"]').trigger('change');
  $('[name="unity_id"]').trigger('change');
  $('[name="business_id"]').trigger('change');
};

const resetGuestsForm = form => {
  $('.c-search--panel').addClass('u-display--none');
  form[0].reset();
  $($('input:disabled'), form[0]).prop('disabled', false);
  $('#ext-warning').hide();
  resetEmployeeFields();
};

// Ao digitar um email que começa com "ext." o sistema bloqueia o radio de funcionário e seleciona o de convidado externo automaticamente
const blockEmailExt = () => {
  const $email = document.getElementById('email');
  const $checkEmployee = document.querySelector('[id="customRadio1"][name="volunteer_type"][value="employee"]');
  const $checkExternal = document.querySelector('[id="customRadio4"][name="volunteer_type"][value="external"]');
  const $extWarning = document.getElementById('ext-warning');

  $email.addEventListener('input', e => {
    if (e.target.value.startsWith('ext.') && e.target.value !== '') {
      $checkEmployee.disabled = true;
      $checkEmployee.checked = false;
      $($checkExternal).trigger('click');
      $extWarning.style.display = 'block';
    } else {
      $checkEmployee.disabled = false;
      $extWarning.style.display = 'none';
    }
  });
};

const index = {
  init() {
    regional();
    unity();
    business();
    blockEmailExt();
    modalSaveReport();

    let $errorMsg = $('.js-participantes-error');

    $('.js-check-volunteers').on('click', function (e) {
      e.preventDefault();

      $errorMsg.hide();

      let employees = $('.employee').filter(':checked').length;
      let externals = $('.external').filter(':checked').length;
      let provider = $('.provider').filter(':checked').length;
      let trainee = $('.trainee').filter(':checked').length;

      $('#js-total-employees').html(employees);
      $('#js-total-external').html(externals);
      $('#js-total-provider').html(provider);
      $('#js-total-trainee').html(trainee);
    });

    $('.js-presence-validate').on('click', function (e) {
      let $errorMsg = $('.js-participantes-error');

      if (
        $('.employee').filter(':checked').length <= 0 &&
        $('.external').filter(':checked').length <= 0 &&
        $('.provider').filter(':checked').length <= 0 &&
        $('.trainee').filter(':checked').length <= 0
      ) {
        e.preventDefault();
        $errorMsg.show();
      } else {
        $errorMsg.hide();
      }
    });

    $('.js-checkall').on('click', function (e) {
      e.preventDefault();
      if (!$("input[name='js-checkall']").prop('checked')) $('input[type=checkbox]').prop('checked', true);
      else $('input[type=checkbox]').prop('checked', false);
    });

    $('.js-form-search').on('keyup', function (e) {
      e.preventDefault();
      w3.filterHTML('.table', '.subscribe-user', $(this).val());
    });

    $('.js-adduser').on('click', function (e) {
      e.preventDefault();
      $('#presence-list').removeClass('active');
      $('#presence-add').addClass('active');
    });

    $('.js-cancell-adduser').on('click', function (e) {
      e.preventDefault();
      $('#presence-list').addClass('active');
      $('#presence-add').removeClass('active');
      $('#guests-table').html('');
    });

    $(document).on('click', '.js-close-panel', function (e) {
      e.preventDefault();
      resetGuestsForm($(this).closest('form'));
    });

    $(document).on('click', '.js-new-guest', function (e) {
      e.preventDefault();
      $('.js-form-add-users').val();
      $('#js-results').html('');
      $('#new-guest').removeClass('u-display--none');
      $('.c-search--panel-message').addClass('u-display--none');
    });

    $(document).on('keyup', '.js-form-add-users', function (e) {
      e.preventDefault();

      if (!$('#new-guest').is(':visible')) {
        $('.c-search--panel-message').removeClass('u-display--none');
      }

      if ($(this).val().length >= 1) {
        $('.c-search--panel').removeClass('u-display--none');
      } else {
        $('.c-search--panel').addClass('u-display--none');
      }

      // Regex para validar email
      const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // Regex para validar número de 6 a 11 dígitos
      const regexNumero = /^\d{6,11}$/;

      // se string for maior que 3 caracteres e for um email ou matrícula
      if ($(this).val().length >= 3 && (regexEmail.test($(this).val()) || regexNumero.test($(this).val()))) {
        $('.c-message--label').addClass('u-display--none');

        var post = {};

        post.term = $(this).val();
        post._token = $('meta[name="csrf-token"]').attr('content');
        post.challenge_id = $(this).attr('data-challenge');

        $.ajax({
          type: 'POST',
          url: '/pesquisa-voluntarios/' + post.term + '/challenge',
          data: post,
          dataType: 'json',
          success: function (data) {
            $('#js-results').html(data.html);
          },
        });
      } else {
        $('#new-guest').addClass('u-display--none');
        $('.c-message--label').removeClass('u-display--none');
        $('#js-results').html('');
      }
    });

    $(document).on('change', '.js-volunteer-type', function () {
      if (
        $("input[name='volunteer_type']:checked").val() == 'employee' ||
        $("input[name='volunteer_type']:checked").val() == 'trainee'
      ) {
        $('#employee_fields').removeClass('u-display--none');
      } else {
        resetEmployeeFields();
        $('#employee_fields').addClass('u-display--none');
      }
    });

    // Faz a inscrição do usuário selecionado
    const subscription = (challenge_id, user_id) => {
      $.ajax({
        type: 'POST',
        url: '/efetuar-inscricao/challenge',
        data: {
          challenge_id,
          user_id,
          _token: $('meta[name="csrf-token"]').attr('content'),
        },
        dataType: 'json',
        success: function (data) {
          if (data.type === 'success') {
            $('#subscribes-table').append(data.html);
            $('#guests-table').append(data.html);
            $('#counter').html(data.subscribes);

            Swal.fire(data.title, data.message, data.type);

            $('.js-form-add-users').text = '';
            $('.c-search--panel').addClass('u-display--none');
          } else {
            Swal.fire(data.title, data.message, data.type);
          }
        },
      });
    };

    $(document).on('click', '.js-add-presence', function (e) {
      e.preventDefault();

      const challenge_id = $(this).attr('data-challenge');
      const user_id = $(this).attr('data-user');
      const has_form = !!$('[name="has_form"]').length;

      if (has_form) {
        callSubscribesForm(challenge_id, user_id);
      } else {
        subscription(challenge_id, user_id);
      }
    });

    // Função de submit e post do form
    submitSubscribesForm(subscription);

    //** Mostra mensagem de mínimo de caracteres no campo de matrícula
    const $enrollment = document.getElementById('enrollment');
    const $enrollmentWarning = document.getElementById('enrollment-warning');

    $enrollment.addEventListener('input', e => {
      e.target.value.length < 6
        ? ($enrollmentWarning.style.display = 'block')
        : ($enrollmentWarning.style.display = 'none');
    });
    //*

    $(document).on('click', '.js-add-presence-user', function (e) {
      e.preventDefault();

      if (
        $("input[name='name']").val() == '' ||
        $("input[name='email']").val() == '' ||
        !$("input[name='volunteer_type']").is(':checked')
      ) {
        Swal.fire(tr[lang].modal_attention, tr[lang].modal_fields, 'error');
        return false;
      }

      if (!isValidEmail($("input[name='email']").val().trim())) {
        Swal.fire(tr[lang].modal_attention, tr[lang].modal_error_email, 'error');
        return false;
      }

      if (
        $('.js-volunteer-type:checked')[0].value == 'employee' &&
        ($('input[name="enrollment"]').val().length < 6 ||
          !$('[name="regional_id"]').val() ||
          !$('[name="unity_id"]').val() ||
          !$('[name="business_id"]').val() ||
          $('[name="leadership"]').val() == '')
      ) {
        Swal.fire(tr[lang].modal_attention, tr[lang].modal_fields, 'error');
        return false;
      }

      var form = $(this).closest('form');
      var post = form.serialize();

      $.ajax({
        type: 'POST',
        url: '/visitante',
        data: post,
        dataType: 'json',
        success: function (data) {
          if (data.type === 'success') {
            $('#subscribes-table').append(data.html);
            $('#guests-table').append(data.html);
            $('#counter').html(data.subscribes);
            resetGuestsForm(form);

            Swal.fire(data.title, data.message, data.type);
          } else {
            Swal.fire(data.title, data.message, data.type);
          }
        },
      });

      return false;
    });

    $('.continue').on('click', function (e) {
      e.preventDefault();

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');

      if (currentSlide == 'volunteers') {
        if ($("input[name='total_employees']").val() == '') {
          Swal.fire(tr[lang].modal_attention, tr[lang].modal_fields, 'error');
          return false;
        }
      }

      if (currentSlide == 'hours') {
        if ($("input[name='total_time_action']").val() == '') {
          Swal.fire(tr[lang].modal_attention, tr[lang].modal_fields, 'error');
          return false;
        }
      }

      if (currentSlide == 'benefiteds') {
        if (
          $("input[name='total_benefited_child']").val() == '' ||
          $("input[name='total_young']").val() == '' ||
          $("input[name='total_adults']").val() == '' ||
          $("input[name='total_seniors']").val() == ''
        ) {
          Swal.fire(tr[lang].modal_attention, tr[lang].modal_fields, 'error');
          return false;
        }
      }

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');
    });

    $('.back').click(function (e) {
      e.preventDefault();

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');

      if (nextSlide == 'rede') {
        if ($("input[name='volunteer_type']:checked").val() == 'employee') {
          nextSlide = 'rede';
        } else {
          nextSlide = 'state';
        }
      }

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');
    });
  },
};

export default index;
